export default {
  data() {
    return {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
    }
  },
  methods: {
    birthdateToTimestamp(birthdate) {
      let extractedNumbers = birthdate.replace(/\D/g, '')
      let constructedDate = new Date(extractedNumbers.slice(4, 8), extractedNumbers.slice(0, 2) - 1, extractedNumbers.slice(2, 4))
      if (constructedDate.getTime()) {
        return Date.UTC(constructedDate.getFullYear(), constructedDate.getMonth(), constructedDate.getDate(), 12) / 1000
      }
    },
    getTypeForFile(file) {
      let recordTypesDictionary = {
        'IMAGE_READ': 'MRI Report',
        'MRI': 'MRI Image',
        'PRE_OP_NOTE': 'Pre-operative Note',
        'POST_OP_NOTE': 'Post-operative Note',
        'OP_NOTE': 'Operative Note',
        'OFFICE_VISIT': 'Office Visit',
        'MESSAGE': 'Clinical Message',
        'XRAY': 'X-Ray',
        'OTHER_IMAGING': 'Imaging',
        'LAB_RESULT': 'Lab Result',
        'PROGRESS_NOTE': 'Progress Note',
        'DIAGNOSTIC_REPORT': 'Diagnostic Report',
        'REFERRAL': 'Referral',
        'COMPLETED_PRIOR_AUTH': 'Completed Prior-Auth',
        'UNKNOWN': 'Medical Record'
      }
      if (file.recordType) {
        if (recordTypesDictionary[file.recordType]) {
          return recordTypesDictionary[file.recordType]
        } else {
          return 'Medical Record'
        }
      } else {
        return 'Medical Record'
      }
    },
    getTimestampOfStartOfThisMonth() {
      let nowdate = new Date()
      let monthStartDay = new Date(nowdate.getFullYear(), nowdate.getMonth(), 1)

      monthStartDay.setHours(0, 0, 0, 0)
      let monthStartDayCutoff = monthStartDay.getTime() / 1000
      return monthStartDayCutoff
    },
    getCurrentMonthName() {
      let nowdate = new Date()
      return this.shortMonths[nowdate.getMonth()]
    },
    getTimestampOfStartOfPreviousMonth() {
      let nowdate = new Date()
      let year = nowdate.getFullYear()
      let month = nowdate.getMonth()

      if (month === 0) {
        month = 11
        year = year - 1
      } else {
        month = month - 1
      }
      let monthStartDay = new Date(year, month, 1)

      monthStartDay.setHours(0, 0, 0, 0)
      let monthStartDayCutoff = monthStartDay.getTime() / 1000
      return monthStartDayCutoff
    },
    getPreviousMonthName() {
      let nowdate = new Date()
      let month = nowdate.getMonth()

      if (month === 0) {
        month = 11
      } else {
        month = month - 1
      }

      return this.shortMonths[month]
    },
    getDateStringFromTimestamp(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    getBirthdateStringFromTimestamp(timestamp) {
      let d = new Date(timestamp * 1000)
      let MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
      return MyDateString
    },
    getLongDateStringFromTimestamp(timestamp) {
      let d = new Date(timestamp * 1000)
      return this.days[d.getDay()] + ' ' + this.months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear()
    },
    getMediumDateWithDayDateStringFromTimestamp(timestamp) {
      let d = new Date(timestamp * 1000)
      return this.shortDays[d.getDay()] + ' ' + this.shortMonths[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear()
    },
    dateForSortingFromTimestamp(timestamp) {
      // this method takes a timestamp and returns a date string in the format yyyymmdd
      let d = new Date(timestamp * 1000)
      return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2)
    },
    providerDisplayNameFromProviderObject(provider) {
      if (provider) {
        if (provider.firstName) {
          let name = provider.firstName + ' ' + provider.lastName

          if (provider.credentials) {
            name = name + ' ' + provider.credentials
          }
          return name
        }
        if (provider.organizationName) {
          return provider.organizationName
        }
        if (provider.coveredEntityName) {
          return provider.coveredEntityName
        }
      }
    },
    providerDisplayAddressFromProviderObject(provider) {
      if (provider.address) {
        let addressString = provider.address.line1
        if (provider.address.line2) {
          addressString = addressString + ' ' + provider.address.line2
        }

        addressString = addressString + ' ' + provider.address.city + ' ' + provider.address.state + ' ' + provider.address.zip

        return addressString
      }
      return ''
    },
    patientDisplayAddressFromPatientObject(patient) {
      if (patient.address) {
        let addressString = patient.address.line1
        if (patient.address.line2) {
          addressString = addressString + ' ' + patient.address.line2
        }

        addressString = addressString + ' ' + patient.address.city + ' ' + patient.address.state + ' ' + patient.address.zip

        return addressString
      }
      return 'Missing Address'
    },
    shouldShowPendingProviderReview(timestamp) {
      let nowdate = new Date().getTime() / 1000

      let timestampOfWhenThePatientCanViewTheDocument = this.businessDaysFromDate(timestamp, 2)
      console.log(timestampOfWhenThePatientCanViewTheDocument)

      if (nowdate > timestampOfWhenThePatientCanViewTheDocument) {
        return false
      } else {
        return true
      }
    },
    businessDaysFromDate(d, businessDays) {
      let date = new Date(d * 1000)
      var counter = 0
      var tmp = new Date(date)
      while (businessDays >= 0) {
        tmp.setTime(date.getTime() + counter * 86400000)
        if (this.isBusinessDay(tmp)) {
          --businessDays
        }
        ++counter
      }
      return tmp.getTime() / 1000
    },
    isBusinessDay (date) {
      var dayOfWeek = date.getDay()
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        // Weekend
        return false
      }
      let holidays = [
        '12/31+5',
        '1/1',
        '1/2+1',
        '1-3/1',
        '2-3/1',
        '5~1/1',
        '7/3+5',
        '7/4',
        '7/5+1',
        '9-1/1',
        '10-2/1',
        '11/10+5',
        '11/11',
        '11/12+1',
        '11-4/4',
        '12/24+5',
        '12/25',
        '12/26+1'
      ]
      var dayOfMonth = date.getDate()
      var month = date.getMonth() + 1
      var monthDay = month + '/' + dayOfMonth
      if (holidays.indexOf(monthDay) > -1) {
        return false
      }
      var monthDayDay = monthDay + '+' + dayOfWeek
      if (holidays.indexOf(monthDayDay) > -1) {
        return false
      }
      var weekOfMonth = Math.floor((dayOfMonth - 1) / 7) + 1
      var monthWeekDay = month + '-' + weekOfMonth + '/' + dayOfWeek
      if (holidays.indexOf(monthWeekDay) > -1) {
        return false
      }
      var lastDayOfMonth = new Date(date)
      lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1)
      lastDayOfMonth.setDate(0)
      var negWeekOfMonth = Math.floor((lastDayOfMonth.getDate() - dayOfMonth - 1) / 7) + 1
      var monthNegWeekDay = month + '~' + negWeekOfMonth + '/' + dayOfWeek
      if (holidays.indexOf(monthNegWeekDay) > -1) {
        return false
      }
      return true
    },
    transformPartnerIDToHumanReadableName(theID) {
      if (theID.includes('5a4fa82c8e4b74e028665d04')) {
        return 'SmartChoice'
      } else if (theID.includes('5acb94000495d7065c909bc2')) {
        return 'Grayhawk'
      } else if (theID.includes('5b73507c4aef2028740f662b')) {
        return 'ImagineMD'
      } else if (theID.includes('5a3f56ec92808ba8d3d5a391')) {
        return 'Newpark'
      } else {
        return 'invalidID: ' + theID
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/mixins/HelperMixin.js